module.exports = __webpack_public_path__ + "static/media/06240007-y4TzwSgs.e6d1c77c.JPG";